/* eslint-disable no-unused-vars */
import React, { useCallback, useEffect, useRef, useState } from "react";

import { Checkbox, Switch, Tooltip } from "antd";
import { Form, Formik } from "formik";
import { Select as FormikSelect } from "formik-antd";
import { filter, pathOr } from "ramda";
import { Else, If, Then } from "react-if";
import { useDispatch, useSelector } from "react-redux";

import moment from "moment";
import { setPopup } from "../../../../actions/popupAction";
import {
  BroadcastTemplateDivider,
  cloackIcon,
  deleteIcon,
  VoiceIcon,
  WarningIcon,
} from "../../../../assets/svg";
import BottomBar from "../../../../components/bottomBar";
import ConfirmPopup from "../../../../components/confirmPopup";
import useWindowDimensions from "../../../../components/custom-hooks/useWindowDimensions";
import CustomButton from "../../../../components/customButton";
import CustomInput from "../../../../components/customInput";
import CustomLabel from "../../../../components/customLabel";
import CustomModal from "../../../../components/customModal";
import CustomSelect from "../../../../components/customSelect";
import {
  messageTypes,
  MOBILE_WIDTH,
  MODALITY_TYPES,
  PRACTICE_EDITION_WHITELABEL,
  CONVO_TYPE,
} from "../../../../constants/constants";
import { getSortedStringValues } from "../../../../helper/helpers";
import CommonService from "../../../../service/CommonService";
import emailEditorservice from "../../../../service/emailEditorService";
import loginService from "../../../../service/login";
import UserService from "../../../../service/UserService";
import AddEditSchedule from "../addEditSchedule";
import DataTable from "../dataTable";
import CreateEmailTemplate from "../emailEditor/CreateEmailTemplate";
import SendMessage from "../SendMessage/sendMessage";
import SendMessageRcs from "../SendMessage/sendMessageRcs";
import { allowOnlyEnglishLetter } from "./constants";

import BroadcastUserService from "../../../../service/BroadcastUserService";
import "./styles.scss";

const THROTTLE_FREQUENCY_UNITS = {
  mins: "minute(s)",
  hours: "hour(s)",
};

const TemplateSelect = (props) => (
  <FormikSelect
    showSearch={true}
    notFoundContent="Not available"
    filterOption={(input, option) =>
      (option && option.label ? option.label : "")
        .toString()
        .toLowerCase()
        .includes(input.toLowerCase())
    }
    {...props}
  />
);

const BroadcastMessage = (props) => {
  const commonservice = new CommonService();
  const userservice = new UserService();
  const audioRef = useRef("");
  const {
    loading,
    headers,
    modal,
    data,
    showTable,
    fileName,
    broadcastMessage,
    onCancel,
    showCancelButton = false,
    showCheckboxes = false,
    typeLabel,
    hasCancel,
    fetchTableData,
    getSuggestions,
    count,
    rowSelection,
    getScheduledMsgData,
    showBroadcastResend,
    handleParentLoading,
    getEmployeeSendAnotherMsg,
    current = null,
    nextPage = null,
    prevPage = null,
    isDirectTextInput = false,
    isMultiLang,
    handleEmailTemplateData,
    fileId,
    customFileId = "",
  } = props;

  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  const isMobileScreen = width < MOBILE_WIDTH ? true : false;
  const deleteRef = useRef(false);
  const currentUser = useSelector((state) => state.login.user);
  const isTemplateModificationAllowed = ["OU", "TS"].includes(
    currentUser?.roles?.roleKey,
  );
  const broadcastService = new BroadcastUserService();
  const { Option } = FormikSelect;
  const isPatientMultiLang = typeLabel === "Patients" && isMultiLang;

  const formInitialValues = {
    convoType: isPatientMultiLang
      ? CONVO_TYPE.SMS
      : PRACTICE_EDITION_WHITELABEL && !isDirectTextInput
        ? CONVO_TYPE.EMAIL
        : CONVO_TYPE.SMS,
    subtype: false,
    template: "",
    message: "",
    useSmsForIVR: false,
    tempMessage: "",
    messageType: false,
    ivrMessage: "",
    ivrTemplate: "",
    ivrTempMessage: "",
    ivrMessageType: messageTypes.custom,
    responseTemplate: "",
    responseMessage: "",
    responseTempMessage: "",
    optOutTemplate: "",
    optOutMessage: "",
    optOutTempMessage: "",
    optOutMessageType: messageTypes.custom,
    responseMessageType: messageTypes.custom,
    data: [],
    language: "",
    override: false,
    sendSurvey: false,
    rcsTemplate: "",
    rcsMessage: "",
    rcsTempMessage: "",
    rcsTemplateId: "",
  };
  const [state, setState] = useState({
    templates: [],
    ivrTemplates: [],
    rcsTemplates: [],
    optOutTemplates: [],
    smsTemplates: [],
    responseTemplate: [],
    scheduleModal: false,
    error: "",
    templateInEditState: false,
    deleteTemplateModal: false,
    deleteTemplateType: "",
    deleteTemplateData: {},
    isAudioValid: true,
    audioRef: null,
    emailTemplatesList: [],
    surveyTemplateList: [],
    createTemplate: false,
    loadingSpinner: false,
    sendMessageState: false,
    scheduledDate: "",
    scheduledTime: "",
    scheduledDateSms: "",
    scheduledDateIvr: "",
    scheduledTimeSms: "",
    scheduledTimeIvr: "",
    timeZoneString: "",
    override: false,
    convoTypeValue: "",
    setAutoFiled: false,
    overrideBothSmsIvr: false,
    languageState: [],
    responseMsgEnabled: false,
    isRcsForBroadcast: false,
    responseMsg: "",
    liveChatNumber: "",
    isDuplicatedEntry: false,
    initialValue: formInitialValues,
    showDuplicateEntryModal: false,
    showScheduleDuplicationModal: false,
    scheduleDuplicationModalData: {},
    duplicationEntryDate: "",
    accountsList: [],
    allAccountsList: [],
    workflowCategory: "",
    translationObject: {},
    hasTranslationError: false,
    hasScheduleTranslationError: false,
    isThrottleEnabled: false,
  });
  const [rcsData, setRcsData] = useState({ data: [], count: 0 });
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const [currentIndex, setCurrentIndex] = useState(0);

  const [headersForSMS, setHeadersForSMS] = useState(headers);

  useEffect(
    () => {
      setHeadersForSMS(headers);
    },
    [headers],
  );

  const { accountsList, allAccountsList } = state;

  const fetchAccounts = (page = 1, searchQuery) => {
    return new Promise(async (resolve, reject) => {
      try {
        let accountsList = [];
        let count = 0;
        const responseData = await userservice.getPortalAccountsForAdmin(
          page,
          searchQuery,
        );
        accountsList = responseData.rows;
        count = responseData.count;

        setState((st) => ({
          ...st,
          accountsList: accountsList,
          allAccountsList: !searchQuery ? accountsList : st.allAccountsList,
        }));
        resolve(count);
      } catch (err) {
        reject(err);
        setPopup({
          customPopupMessage: true,
          message: pathOr(
            "Internal Server Error. Please check the connection",
            ["response", "data", "message"],
            err,
          ),
          messageType: "error",
        });
      }
    });
  };

  // This assumes you have an 'rcsService' similar to the one used in DialogModal
  const fetchRcsTemplates = async (practiceId) => {
    try {
      // You'll need to implement or import a service to get RCS templates
      const data = await broadcastService.getTemplatesByPracticeId(practiceId);
      setRcsData(data);
      setState((st) => ({
        ...st,
        rcsTemplates: data.data || [],
      }));
    } catch (err) {
      console.error("Error fetching RCS templates:", err);
    }
  };

  // Create this new handler function inside your BroadcastMessage component
  const handleRcsTemplateChange = (selectedKey, setFieldValue) => {
    setFieldValue("rcsTemplateId", selectedKey);
    setCurrentIndex(0); // Reset for carousels

    const template = rcsData.data?.find(
      (t) => t.contentTemplateSid === selectedKey,
    );

    if (template) {
      try {
        const parsedContent = JSON.parse(template.contentPayload);
        setSelectedTemplate({ ...template, parsedContent });

        // Optional: Auto-fill the message box with the card title
        const card = parsedContent.types?.["twilio/card"];
        const carousel = parsedContent.types?.["twilio/carousel"];
        let messageText = "";
        if (card?.title) {
          messageText = card.title;
        } else if (carousel?.cards?.[0]?.title) {
          messageText = carousel.cards[0].title;
        }
        // setFieldValue("rcsMessage", messageText);
      } catch (error) {
        console.error("Error parsing RCS template:", error);
        setSelectedTemplate(null);
      }
    } else {
      setSelectedTemplate(null);
      setFieldValue("rcsMessage", "");
    }
  };

  const liveChatFieldVariable = {
    Header: "LiveChatNumber",
    accessor: "LiveChatNumber",
    index: headers?.length + 1,
  };
  const surveyFieldVariable = {
    Header: "SurveyLink",
    accessor: "",
    index: headers?.length + 1,
  };

  const replaceFieldVariables = (message = "", formattedHeaders = []) => {
    if (!message || !Array.isArray(formattedHeaders) || !formattedHeaders.length) {
      return message;
    }

    return formattedHeaders.reduce((formattedMessage, header) => {
      if (!header?.Header) {
        return formattedMessage;
      }

      const replacementKey = header.accessor || header.Header;

      const regex = new RegExp(
        `{${header.Header.replace(/[.*+?^${}()|[\]\\]/g, "\\$&")}}`,
        "g",
      );

      return formattedMessage.replace(regex, `{${replacementKey}}`);
    }, message);
  };
  //Format column headings based on convoType selected
  const formatTableColumns = (headers, val) => {
    const getTitle = (header, val) => {
      if (header.Header === "PhoneNo" && val === CONVO_TYPE.EMAIL) {
        return "Column_1";
      } else if (header.Header === "PhoneNo") {
        return "Cell Number";
      } else if (
        header.Header === "LandlineNo" &&
        val !== CONVO_TYPE.AUTO &&
        typeLabel !== "Appointment"
      ) {
        return "Column_2";
      } else {
        return header.Header;
      }
    };
    return headers.map((header) => ({
      //title: header.Header === 'CellPhone' ? 'Phone No.' : header.Header,
      title: getTitle(header, val),
      dataIndex: header.accessor,
      key: header.accessor,
      accessor: getTitle(header, val),
      Header: getTitle(header, val),
      ellipsis: true,
      sorter: (a, b) =>
        getSortedStringValues(a[header.accessor], b[header.accessor]),
      width: "20rem",
    }));
  };

  //Format the headers being sent to sendMessage to sync 'Add Field Variables'
  const formatHeaders = (headers, val) => {
    const getHeader = (header) => {
      if (
        header === "LandlineNo" &&
        val !== CONVO_TYPE.AUTO &&
        typeLabel !== "Appointment"
      ) {
        return "Column_2";
      } else {
        return header;
      }
    };
    return headers.map((item, index) => ({
      Header: getHeader(item.Header),
      accessor: item.accessor,
      index: index + 1,
    }));
  };

  const getType = (typeLabel, convoType = CONVO_TYPE.SMS) => {
    let type = "";
    if (typeLabel === "Patients") {
      if (convoType === CONVO_TYPE.IVR) {
        type = "b-patient-ivr";
      } else if (convoType === CONVO_TYPE.RCS) {
        type = "b-patient-rcs";
      } else {
        type = "b-patient";
      }
    } else if (typeLabel === "Employees") {
      if (convoType === CONVO_TYPE.IVR) {
        type = "b-employee-ivr";
      } else if (convoType === CONVO_TYPE.RCS) {
        type = "b-employee-rcs";
      } else {
        type = "b-employee";
      }
    } else if (typeLabel === "Appointment") {
      if (convoType === CONVO_TYPE.IVR) {
        type = "b-appointment-ivr";
      } else if (convoType === CONVO_TYPE.RCS) {
        type = "b-appointment-rcs";
      } else {
        type = "b-appointment";
      }
    }

    return type;
  };

  const getIvrTemplateType = () => {
    return `${getType(typeLabel)}-ivr`;
  };

  const getrcsTemplateType = () => {
    return `${getType(typeLabel)}-rcs`;
  };
  const listOfOptOutTemplates = async () => {
    try {
      const listResponse = await commonservice.getTemplateList("opt-out");

      setState((st) => ({
        ...st,
        optOutTemplates: listResponse,
      }));
    } catch (err) {
      dispatch(
        setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: pathOr(
            "Something went wrong",
            ["response", "data", "errors", "message"],
            err,
          ),
        }),
      );
    }
  };
  const getLivechatConfiguration = async () => {
    try {
      const listResponse = await commonservice.getLivechatConfiguration();
      const {
        responseMsgEnabled,
        isRcsForBroadcast,
        liveChatNumber,
        responseMsg = "",
        isAgentChat = false,
        agentChatQueueId = "",
        workflowCategory = "",
      } = listResponse;
      setState((st) => ({
        ...st,
        responseMsgEnabled,
        liveChatNumber,
        isRcsForBroadcast,
        initialValue: {
          ...st.initialValue,
          responseMessage: responseMsg,
        },
        isAgentChat,
        agentChatQueueId,
        workflowCategory,
      }));
    } catch (err) {
      dispatch(
        setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: pathOr(
            "Something went wrong",
            ["response", "data", "errors", "message"],
            err,
          ),
        }),
      );
    }
  };

  const getThrottleStatus = async () => {
    try {
      const throttleConfig = await broadcastService.getThrottleConfig();
      setState((st) => ({
        ...st,
        isThrottleEnabled: !!throttleConfig?.isEnabled,
        throttleTypeValue: throttleConfig?.throttleTypeValue,
        throttleType: throttleConfig?.throttleType,
      }));
    } catch (err) {
      console.log(err);
    }
  };

  const getFilteredModalityTypes = (
    isDirectTextInput,
    typeLabel,
    isRcsForBroadcast,
  ) => {
    let filteredTypes = MODALITY_TYPES;

    const isEnableRcs = loginService.getEnableRcs();

    // Filter based on direct text input
    if (isDirectTextInput) {
      filteredTypes = filteredTypes.filter(
        (type) =>
          type.value !== CONVO_TYPE.AUTO && type.value !== CONVO_TYPE.EMAIL,
      );
    }

    // For patient multi-language broadcasts, only show supported modalities.
    if (isPatientMultiLang) {
      filteredTypes = filteredTypes.filter(
        (type) =>
          type.value !== CONVO_TYPE.IVR &&
          type.value !== CONVO_TYPE.AUTO &&
          type.value !== CONVO_TYPE.EMAIL,
      );
    }

    // Filter for appointment type
    if (typeLabel === "Appointment" && !PRACTICE_EDITION_WHITELABEL) {
      filteredTypes = filteredTypes.filter(
        (type) => type.value !== CONVO_TYPE.EMAIL,
      );
    }
    // Filter out RCS if not enabled for broadcast
    if (!(isRcsForBroadcast && isEnableRcs)) {
      filteredTypes = filteredTypes.filter(
        (type) => type.value !== CONVO_TYPE.RCS,
      );
    }

    return filteredTypes;
  };
  const listOfIvrTemplates = async () => {
    try {
      const typeOfTemplate = getIvrTemplateType();

      const listResponse = await commonservice.getTemplateList(typeOfTemplate);

      setState((st) => ({
        ...st,
        ivrTemplates: listResponse,
      }));
    } catch (err) {
      dispatch(
        setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: pathOr(
            "Something went wrong",
            ["response", "data", "errors", "message"],
            err,
          ),
        }),
      );
    }
  };

  const listOfSmsTemplates = async () => {
    try {
      const listResponse = await commonservice.getTemplateList("b-reply");

      setState((st) => ({
        ...st,
        smsTemplates: listResponse,
      }));
    } catch (err) {
      dispatch(
        setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: pathOr(
            "Something went wrong",
            ["response", "data", "errors", "message"],
            err,
          ),
        }),
      );
    }
  };

  const listOfTemplates = async (convoType = CONVO_TYPE.SMS) => {
    try {
      const typeOfTemplate = getType(typeLabel, convoType);

      const listResponse = await commonservice.getTemplateList(typeOfTemplate);
      setState((st) => ({
        ...st,
        templates: listResponse,
      }));
    } catch (err) {
      dispatch(
        setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: pathOr(
            "Something went wrong",
            ["response", "data", "errors", "message"],
            err,
          ),
        }),
      );
    }
  };

  const getTemplateMsg = async (id, setFieldValue, name, tempName) => {
    // Here name is the input textarea that is getting updated
    // Here tempName is the templateMessage, we need this because when we edit this template message, we need to store our previous template message text also
    try {
      const msg = await commonservice.getTemplateMsg(id);

      setFieldValue(name, msg.templateMessage);
      setFieldValue(tempName, msg.templateMessage);
    } catch (err) {
      dispatch(
        setPopup({
          customPopupMessage: true,
          messageType: "error",
          message: pathOr(
            "Something went wrong",
            ["response", "data", "errors", "message"],
            err,
          ),
        }),
      );
    }
  };

  const handleReset = (setFieldValue, selectedTempType) => {
    setFieldValue(selectedTempType, "");
  };

  const hideScheduleModal = () => {
    setState((st) => ({
      ...st,
      scheduleModal: false,
    }));
  };

  const handleModal = async (values, e) => {
    e.preventDefault();

    const { selectedCount, selectAll } = getScheduledMsgData(values);

    if (typeLabel === "Employees" && !selectedCount) {
      setState((st) => ({
        ...st,
        scheduleModal: false,
      }));

      dispatch(
        setPopup({
          customPopupMessage: true,
          message: "Please select at least one contact.",
          messageType: "error",
        }),
      );
      return;
    }

    if (typeLabel === "Appointment" && !selectAll && !selectedCount) {
      setState((st) => ({
        ...st,
        scheduleModal: false,
      }));

      dispatch(
        setPopup({
          customPopupMessage: true,
          message: "Please select at least one appointment.",
          messageType: "error",
        }),
      );
      return;
    }

    let hasScheduleTranslationError = false;
    let translationObject = {};
    let translationErrorMessage = "";
    if (typeLabel === "Patients" && isMultiLang) {
      try {
        const response = await broadcastService.translationOfMessage({
          selectAll: true,
          fileId,
          message: values?.message || values?.rcsMessage,
          userType: "patient",
        });
        const rawHasTranslationError = response?.data?.hasError;
        hasScheduleTranslationError =
          rawHasTranslationError === true || rawHasTranslationError === "true";
        translationObject = response?.data?.translationObject || {};
        translationErrorMessage =
          response?.data?.translationObject?.errorMessage ||
          response?.data?.errorMessage ||
          response?.data?.errors?.message ||
          response?.data?.message ||
          "";
      } catch (err) {
        hasScheduleTranslationError = true;
        translationErrorMessage =
          pathOr(
            "",
            ["response", "data", "translationObject", "errorMessage"],
            err,
          ) ||
          pathOr("", ["response", "data", "errorMessage"], err) ||
          pathOr("", ["response", "data", "errors", "message"], err) ||
          pathOr("", ["response", "data", "message"], err);
      }
    }

    if (hasScheduleTranslationError) {
      setState((st) => ({
        ...st,
        hasScheduleTranslationError: true,
        translationObject: {},
        scheduleModal: false,
      }));
      dispatch(
        setPopup({
          customPopupMessage: true,
          messageType: "error",
          message:
            translationErrorMessage ||
            "Unable to translate message right now. Broadcast was not sent.",
        }),
      );
      return;
    }

    setState((st) => ({
      ...st,
      hasScheduleTranslationError: false,
      translationObject,
      scheduleModal: true,
    }));
  };

  const deleteTemplate = async (setFieldValue) => {
    if (deleteRef && deleteRef.current) return;
    else {
      try {
        deleteRef.current = true;
        if (state.deleteTemplateType === CONVO_TYPE.EMAIL) {
          await commonservice.deleteEmailTemplate(state.deleteTemplateData.id);
        } else {
          await commonservice.deleteTemplate(state.deleteTemplateData.id);
        }

        dispatch(
          setPopup({
            customPopupMessage: true,
            messageType: "success",
            message: "Template has been deleted successfully.",
          }),
        );

        setState((st) => ({
          ...st,
          deleteTemplateModal: false,
        }));

        deleteRef.current = false;

        if (state.deleteTemplateType === CONVO_TYPE.IVR) {
          listOfIvrTemplates();
        } else if (state.deleteTemplateType === CONVO_TYPE.RCS) {
          listOfTemplates("rcs", "b-patient-rcs");
        } else if (state.deleteTemplateType === "opt-out") {
          listOfOptOutTemplates();
        } else if (state.deleteTemplateType === "b-reply") {
          listOfSmsTemplates();
        } else if (state.deleteTemplateType === CONVO_TYPE.EMAIL) {
          fetchData();
        } else {
          listOfTemplates();
        }
        setFieldValue("template", "");
        setFieldValue("message", "");
        setFieldValue("emailTemplateId", "");
        setState((st) => ({
          ...st,
          deleteTemplateType: "",
        }));
      } catch (err) {
        dispatch(
          setPopup({
            customPopupMessage: true,
            messageType: "error",
            message: pathOr(
              "Something went wrong",
              ["response", "data", "message"],
              err,
            ),
          }),
        );
        setState((st) => ({
          ...st,
          deleteTemplateModal: false,
        }));
        deleteRef.current = false;
      }
    }
  };

  const setFormattedMessage = () => {};

  const ActionTemplate = ({ dirty, isValid, values }) => {
    return (
      <>
        <CustomButton
          className="cancel-button"
          onClick={onCancel}
          title={hasCancel ? "Cancel" : "Discard file"}
        />

        <If
          condition={
            showCancelButton && loginService.getEhrName() === "Nextgen"
          }
        >
          <Then>
            <CustomButton
              htmlType="submit"
              type="primary"
              title="Send and Cancel"
              className={`ml-8 ${
                !isValid || !dirty || loading ? "disable-button" : ""
              }`}
              disabled={!isValid || !dirty || loading}
            />
          </Then>
        </If>

        <section className="send-message-with-schedule-container">
          <CustomButton
            htmlType="submit"
            type="primary"
            title="Send message"
            className={`ml-8 split-button-left ${
              !isValid ||
              !dirty ||
              loading ||
              (values.audio ? state.isAudioValid : null) ||
              (values.sendSurvey && !values.surveyTemplateId)
                ? "disable-button"
                : ""
            } `}
            disabled={
              !isValid ||
              !dirty ||
              loading ||
              (values.audio ? state.isAudioValid : null) ||
              (values.sendSurvey && !values.surveyTemplateId)
            }
          />

          <CustomButton
            type="primary"
            onClick={(e) => handleModal(values, e)}
            title={cloackIcon}
            tooltip="Schedule for later"
            className={`ant-btn-primary split-button-right ${
              !isValid ||
              !dirty ||
              loading ||
              (values.audio ? state.isAudioValid : null) ||
              (values.sendSurvey && !values.surveyTemplateId)
                ? "disable-button"
                : ""
            }`}
            disabled={
              !isValid ||
              !dirty ||
              loading ||
              (values.audio ? state.isAudioValid : null) ||
              (values.sendSurvey && !values.surveyTemplateId)
            }
          />
        </section>
      </>
    );
  };
  //Replacing headers with accessors before sending data to backend
  const formatMessageValues = (values) => {
    const headerNew = formatHeaders(
      getUpdatedHeaders(values.convoType, values.sendSurvey),
      values.convoType,
    );
    const newValues = { ...values };
    const baseMessage =
      values.rcsMessage && values.rcsMessage.trim().length > 0
        ? values.rcsMessage
        : values.message;

    newValues.message = replaceFieldVariables(baseMessage, headerNew);
    newValues.ivrMessage = replaceFieldVariables(values.ivrMessage, headerNew);
    newValues.responseMessage = values.responseMessage
      ? replaceFieldVariables(values.responseMessage, headerNew)
      : "";
    newValues.override = state.override;
    newValues.template = values?.template?.key || "";
    newValues.ivrTemplate = values?.ivrTemplate?.key || "";
    newValues.optOutTemplate = values?.optOutTemplate?.key || "";
    newValues.responseTemplate = values?.responseTemplate?.key || "";
    newValues.ivrVoice = state.languageState?.find(
      (lang) => lang.value === values.language,
    )?.voice;
    newValues.isAgentChat = state.isAgentChat;
    newValues.agentChatQueueId = state.agentChatQueueId;
    newValues.workflowCategory = state.workflowCategory;
    return newValues;
  };

  const onBackButtonClick = () => {
    props.onCancel();
  };

  const onNextButtonClick = () => {
    nextPage();
  };

  const submitForm = (values) => {
    setState((st) => ({ ...st, sendMessageState: false }));
    const newVal = formatMessageValues(values);
    if (typeLabel === "Patients") {
      if (state.hasTranslationError) {
        dispatch(
          setPopup({
            customPopupMessage: true,
            messageType: "error",
            message:
              "Unable to translate message right now. Broadcast was not sent.",
          }),
        );
        return;
      }
      newVal.isMultiLang = isMultiLang;
      newVal.translationObject = state.translationObject || {};
    }
    broadcastMessage(newVal);
  };

  const setAudioRef = (ref) => {
    setState((st) => ({
      ...st,
      audioRef: ref,
    }));
  };

  const updateEmailTemplateList = async () => {
    try {
      const {
        data: emailTemplatesList,
      } = await emailEditorservice.getEmailEditor(practiceId);

      setState((st) => ({
        ...st,
        emailTemplatesList,
      }));
    } catch (e) {
      console.error("Err:", e);
    }
  };

  const practiceId = loginService.getPracticeId();

  const fetchData = async () => {
    try {
      setState((st) => ({
        ...st,
        loadingSpinner: true,
      }));
      const {
        data: emailTemplatesList,
      } = await emailEditorservice.getEmailEditor(practiceId);

      const surveyTemplateList = await commonservice.getSurveyTemplate(
        practiceId,
      );
      setState((st) => ({
        ...st,
        emailTemplatesList,
        surveyTemplateList,
      }));

      setState((st) => ({
        ...st,
        loadingSpinner: false,
      }));
    } catch (err) {
      setState((st) => ({
        ...st,
        loadingSpinner: false,
      }));
    }
  };

  const getLanguageVoiceByCustomer = async () => {
    try {
      const { data } = await commonservice.getLanguageVoicesByCustomer(
        practiceId,
      );
      setState((st) => ({
        ...st,
        languageState: data,
      }));

      if (data?.length) {
        const defaultLanguage =
          data.find((lang) => lang.default)?.value || "eng";
        setState((st) => ({
          ...st,
          initialValue: {
            ...st.initialValue,
            language: defaultLanguage,
          },
        }));
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchData();
    const initializeData = async () => {
      await getLivechatConfiguration();
      await getLanguageVoiceByCustomer();
      await getThrottleStatus();
    };

    initializeData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getUpdatedHeaders = useCallback(
    (convoType, sendSurvey) => {
      let updatedHeaders = headersForSMS;

      if (convoType === CONVO_TYPE.SMS && sendSurvey) {
        updatedHeaders = updatedHeaders.some(
          (header) => header.accessor === surveyFieldVariable.accessor,
        )
          ? updatedHeaders
          : [...updatedHeaders, surveyFieldVariable];
      }

      return updatedHeaders;
    },
    [headersForSMS],
  );

  const createNewTemplateHandler = (values, setFieldValue) => {
    if (!values.emailTemplateId) {
      setFieldValue("accounts", []);
    }
    if (PRACTICE_EDITION_WHITELABEL) {
      handleEmailTemplateData(
        {
          templateId: values.emailTemplateId,
          mergeTags: formatTableColumns(headers, values.convoType) || [],
        },
        !!values.emailTemplateId,
      );
    } else {
      setState((st) => ({
        ...st,
        createTemplate: true,
      }));
    }
  };

  const handleCheckboxChange = (event) => {
    setState((st) => ({
      ...st,
      override: event.target.checked,
    }));
  };

  const confirmSubmitForm = (values) => {
    submitForm(values);
  };

  const submitAddEditForm = async (values) => {
    const updatedValues = { ...values };
    updatedValues.fileId = fileId;
    updatedValues.fileName = fileName;
    updatedValues.customFileId = customFileId;

    delete updatedValues.template;
    delete updatedValues.ivrTemplate;
    delete updatedValues.optOutTemplate;
    delete updatedValues.responseTemplate;
    delete updatedValues.rcsMessage;
    delete updatedValues.rcsTemplate;
    delete updatedValues.rcsTempMessage;

    let translationObject = {};
    let hasTranslationError = false;
    let translationErrorMessage = "";

    handleParentLoading(true);
    await getThrottleStatus();
    try {
      await broadcastService.messageLogs({
        message: values?.message || values.rcsMessage,
        fileId: props.fileId,
        fileName: props.fileName,
        ...(values.convoType === CONVO_TYPE.RCS && {
          templateId: values.rcsTemplateId,
        }),
      });
    } catch (e) {
      console.log(e);
    }
    if (typeLabel === "Patients" && isMultiLang) {
      try {
        const response = await broadcastService.translationOfMessage({
          selectAll: true,
          fileId: props.fileId,
          message: values?.message || values?.rcsMessage,
          userType: "patient",
        });
        translationObject = response?.data?.translationObject || {};

        const rawHasTranslationError = response?.data?.hasError;
        hasTranslationError =
          rawHasTranslationError === true || rawHasTranslationError === "true";
        translationErrorMessage =
          response?.data?.translationObject?.errorMessage || "";
        setState((st) => ({
          ...st,
          hasTranslationError,
          translationObject: hasTranslationError ? {} : translationObject,
        }));
      } catch (e) {
        hasTranslationError = true;
        translationErrorMessage =
          pathOr(
            "",
            ["response", "data", "translationObject", "errorMessage"],
            e,
          ) ||
          pathOr("", ["response", "data", "errorMessage"], e) ||
          pathOr("", ["response", "data", "errors", "message"], e) ||
          pathOr("", ["response", "data", "message"], e);
        setState((st) => ({
          ...st,
          hasTranslationError: true,
          translationObject: {},
        }));
      }
    } else {
      setState((st) => ({
        ...st,
        hasTranslationError: false,
        translationObject: {},
      }));
    }
    if (hasTranslationError) {
      setState((st) => ({
        ...st,
        showDuplicateEntryModal: false,
        isDuplicatedEntry: false,
      }));
      dispatch(
        setPopup({
          customPopupMessage: true,
          messageType: "error",
          message:
            translationErrorMessage ||
            "Unable to translate message right now. Broadcast was not sent.",
        }),
      );
      handleParentLoading(false);
      return;
    }
    try {
      const {
        data: { isDuplicatedEntry },
      } = await commonservice.checkDuplicatedEntry(updatedValues);

      if (isDuplicatedEntry) {
        setState((st) => ({
          ...st,
          duplicationEntryDate: moment().format("MM/DD/YYYY"),
        }));
      }
      setState((st) => ({
        ...st,
        isDuplicatedEntry,
        showDuplicateEntryModal: true,
      }));
    } catch (err) {
      console.log(err);
    } finally {
      handleParentLoading(false);
    }
  };

  return (
    <Formik
      validate={(values) => {
        const errors = {};
        if (
          (!values.message || !/\S/.test(values.message)) &&
          !values.subtype &&
          values.convoType !== CONVO_TYPE.EMAIL &&
          values.convoType !== CONVO_TYPE.RCS
        ) {
          errors.message = "Message is required";
        }
        if (
          isPatientMultiLang &&
          values.convoType !== CONVO_TYPE.EMAIL &&
          values.convoType !== CONVO_TYPE.RCS &&
          values.message &&
          /\S/.test(values.message) &&
          !allowOnlyEnglishLetter(values.message)
        ) {
          errors.message = `The message must be in English only. The message length should be minimum 32 characters with at least 24 alphabets (a-z, A-Z)`;
        }
        if (
          isPatientMultiLang &&
          values.convoType === CONVO_TYPE.RCS &&
          values.rcsMessage &&
          /\S/.test(values.rcsMessage) &&
          !allowOnlyEnglishLetter(values.rcsMessage)
        ) {
          errors.rcsMessage = `The message must be in English only. The message length should be minimum 32 characters with at least 24 alphabets (a-z, A-Z)`;
        }
        if (
          values.convoType === CONVO_TYPE.RCS &&
          (!values.rcsMessage || !/\S/.test(values.rcsMessage))
        ) {
          errors.rcsMessage = "Message is required";
        }
        if (
          values.convoType === CONVO_TYPE.RCS &&
          (!values.rcsTemplateId || values.rcsTemplateId === "")
        ) {
          errors.rcsTemplateId = "";
        }
        if (
          (!values.ivrMessage || !/\S/.test(values.ivrMessage)) &&
          !values.useSmsForIVR &&
          values.convoType === CONVO_TYPE.AUTO
        ) {
          errors.ivrMessage = "Message is required";
        }
        if (
          state.responseMsgEnabled &&
          (!values.responseMessage || !/\S/.test(values.responseMessage))
        ) {
          errors.responseMessage = "Message is required";
        }
        if (
          (!values.optOutMessage || !/\S/.test(values.optOutMessage)) &&
          values.enableOptOut
        ) {
          errors.optOutMessage = "Message is required";
        }
        if (
          values.convoType === CONVO_TYPE.IVR &&
          values.subtype &&
          !values.audio
        ) {
          errors.audio = "Audio file is required";
        }
        if (
          values.convoType === CONVO_TYPE.IVR &&
          values.message.length >= 4000
        ) {
          errors.message =
            "IVR message length exceeded, maximum 4000 characters are allowed.";
        }
        if (values.messageType && !values.template) {
          errors.template = "You must select a template";
        }
        if (values.convoType === CONVO_TYPE.EMAIL && !currentUser.fromEmail) {
          errors.convoType =
            "Email id is not configured. Please contact the admin";
        }
        if (values.convoType === CONVO_TYPE.EMAIL && !values.emailTemplateId) {
          errors.emailTemplateId = "You must select a template";
        }
        if (values.convoType === CONVO_TYPE.EMAIL && !values.emailColumn) {
          errors.emailColumn = "You must select a email column";
        }
        if (
          values.convoType === CONVO_TYPE.EMAIL &&
          !/\S/.test(values.emailSubject)
        ) {
          errors.emailSubject = "You must enter a email subject";
        }

        return errors;
      }}
      enableReinitialize
      initialValues={state.initialValue}
      onSubmit={(values, actions) => submitAddEditForm(values, actions)}
    >
      {({
        values,
        setFieldValue,
        touched,
        errors,
        isValid,
        dirty,
        validateForm,
        resetForm,
        actions,
      }) => {
        useEffect(
          () => {
            const shouldShowAgentChatLink =
              state.isAgentChat &&
              state.agentChatQueueId &&
              (values.convoType === CONVO_TYPE.SMS ||
                values.convoType === CONVO_TYPE.AUTO);

            setHeadersForSMS((prevHeaders) => {
              if (shouldShowAgentChatLink) {
                const agentChatFieldVariable = {
                  Header: "AgentChatLink",
                  accessor: "AgentChatLink",
                  index: prevHeaders.length + 1,
                };
                return prevHeaders.some(
                  (header) => header.accessor === "AgentChatLink",
                )
                  ? prevHeaders
                  : [...prevHeaders, agentChatFieldVariable];
              } else {
                return prevHeaders.filter(
                  (header) => header.accessor !== "AgentChatLink",
                );
              }
            });
          },
          [values.convoType, state.isAgentChat, state.agentChatQueueId],
        );

        const toggleScheduleDuplicationModal = async (
          selectedValues,
          scheduleBroadcast,
        ) => {
          try {
            const updatedValues = { ...selectedValues };
            hideScheduleModal();
            handleParentLoading(true);
            updatedValues.fileId = fileId;
            updatedValues.fileName = fileName;
            updatedValues.convoType = values?.convoType;
            updatedValues.message = values?.message;
            updatedValues.customFileId = customFileId;
            updatedValues.scheduleDate = moment(
              updatedValues.scheduleDate,
            ).format("MM-DD-YYYY");
            delete updatedValues?.template;
            delete updatedValues?.ivrTemplate;

            const {
              data: { isDuplicatedEntry },
            } = await commonservice.checkDuplicatedEntry(updatedValues);
            if (isDuplicatedEntry) {
              setState((st) => ({
                ...st,
                duplicationEntryDate: updatedValues?.scheduleDate,
              }));
            }
            setState((st) => ({
              ...st,
              showScheduleDuplicationModal: !st.showScheduleDuplicationModal,
              scheduleDuplicationModalData: {
                updatedValues,
                scheduleBroadcast,
              },
              isDuplicatedEntry,
            }));
          } catch (e) {
            console.log(e);
          } finally {
            handleParentLoading(false);
          }
        };
        const onSubmitForm = () => {
          submitAddEditForm(values, actions);
        };
        const checkOverrideWindow = async () => {
          handleParentLoading(true);
          setState((st) => ({ ...st, showDuplicateEntryModal: false }));
          try {
            const overRideWindow = await commonservice.getOverridewindow(
              values.convoType,
            );

            if (overRideWindow.sendLater === true) {
              setState((st) => ({
                ...st,
                sendMessageState: true,
                overrideBothSmsIvr: false,
                setAutoFiled: false,
                scheduledDate: overRideWindow?.scheduledDate,
                scheduledTime: overRideWindow?.scheduledTime,
                timeZoneString: overRideWindow?.timeZoneString,
              }));
            } else if (
              overRideWindow?.sendLaterSMS === true &&
              overRideWindow?.sendLaterIVR === false
            ) {
              setState((st) => ({
                ...st,
                sendMessageState: true,
                overrideBothSmsIvr: false,
                setAutoFiled: true,
                convoTypeValue: "SMS",
                scheduledDate: overRideWindow?.scheduledDateSMS,
                scheduledTime: overRideWindow?.scheduledTimeSMS,
                timeZoneString: overRideWindow?.timeZoneString,
              }));
            } else if (
              overRideWindow?.sendLaterSMS === false &&
              overRideWindow?.sendLaterIVR === true
            ) {
              setState((st) => ({
                ...st,
                sendMessageState: true,
                setAutoFiled: true,
                overrideBothSmsIvr: false,
                convoTypeValue: "IVR",
                scheduledDate: overRideWindow?.scheduledDateIVR,
                scheduledTime: overRideWindow?.scheduledTimeIVR,
                timeZoneString: overRideWindow?.timeZoneString,
              }));
            } else if (
              overRideWindow?.sendLaterSMS === true &&
              overRideWindow?.sendLaterIVR === true
            ) {
              setState((st) => ({
                ...st,
                sendMessageState: true,
                setAutoFiled: true,
                convoTypeValue: "SMS & IVR",
                overrideBothSmsIvr: true,
                scheduledDateSms: overRideWindow?.scheduledDateSMS,
                scheduledTimeSms: overRideWindow?.scheduledTimeSMS,
                scheduledDateIvr: overRideWindow?.scheduledDateIVR,
                scheduledTimeIvr: overRideWindow?.scheduledTimeIVR,
                timeZoneString: overRideWindow?.timeZoneString,
              }));
            } else {
              submitForm(values);
            }
          } catch (err) {
            console.log(err);
          } finally {
            handleParentLoading(false);
          }
        };
        const getModalTitle = () => {
          return `${
            state.setAutoFiled
              ? state?.convoTypeValue
              : values.convoType.toUpperCase()
          } Contact Window Closed`;
        };
        const getModalContent = () => {
          return (
            <>
              <p className="broadcast-modal-msg">
                The contact window for{" "}
                {state.setAutoFiled
                  ? state?.convoTypeValue
                  : values.convoType.toUpperCase()}{" "}
                has been closed for today, your{" "}
                {!state.overrideBothSmsIvr && (
                  <span>
                    {state.setAutoFiled
                      ? state?.convoTypeValue
                      : values.convoType.toUpperCase()}{" "}
                    messages will be sent out on {state?.scheduledDate} at{" "}
                    {state.scheduledTime} ({state.timeZoneString}
                    ).
                  </span>
                )}
                {state.overrideBothSmsIvr && (
                  <span className="multiple-modal-msg">
                    SMS messages will be sent out on {state?.scheduledDateSms}{" "}
                    at {state?.scheduledTimeSms} ({state.timeZoneString}
                    ).
                  </span>
                )}
                {state.overrideBothSmsIvr && (
                  <span className="multiple-modal-msg">
                    IVR messages will be sent out on {state.scheduledDateIvr} at{" "}
                    {state.scheduledTimeIvr} ({state.timeZoneString}
                    ).
                  </span>
                )}
              </p>
              <Checkbox
                className="override-checbox"
                onChange={handleCheckboxChange}
              >
                Override contact window and send now
              </Checkbox>
              <br />
            </>
          );
        };
        const getDuplicateModalContent = () => {
          const { isDuplicatedEntry, throttleTypeValue, throttleType } = state;
          const isMultiLangEnabled = typeLabel === "Patients" && isMultiLang;
          const throttleFrequencyText =
            throttleTypeValue && throttleType
              ? `every ${throttleTypeValue} ${THROTTLE_FREQUENCY_UNITS[throttleType] ||
                  throttleType} the configured throttle settings`
              : "";

          return (
            <>
              {/* Section 1: Multi-language Warning (Displayed only if Multi-lang is active) */}
              <If condition={isMultiLangEnabled}>
                <Then>
                  <p className="broadcast-modal-msg mb-16">
                    This is a multi-language broadcast, please ensure the
                    message is in English only to avoid incorrect translation.
                  </p>
                </Then>
              </If>

              {/* Section 2: Throttle Warning (Displayed only if throttling is enabled) */}
              <If condition={state.isThrottleEnabled}>
                <Then>
                  <div className="duplication-entry-container mb-16">
                    <p className="heading-container">
                      <span className="warning-icon">{WarningIcon}</span>
                      <span className="heading">Throttling is enabled</span>
                    </p>
                    <p className="description">
                      Outreach will be sent {throttleFrequencyText}.
                    </p>
                  </div>
                </Then>
              </If>

              {/* Section 3: File Duplication Alert (Displayed only if backend detects a duplicate) */}
              <If condition={isDuplicatedEntry}>
                <Then>
                  <div className="duplication-entry-container mb-16">
                    <p className="heading-container">
                      <span className="warning-icon">{WarningIcon}</span>
                      <span className="heading">
                        Duplicate Broadcast detected
                      </span>
                    </p>
                    <p className="description">
                      The broadcast submission for the same file has been
                      detected on date {state?.duplicationEntryDate}. Please
                      ensure and confirm if you want to re-send the broadcast
                      for the same file.
                    </p>
                  </div>
                </Then>
              </If>

              {/* Section 4: Review Instructions (The "rest of need" section) */}
              <p className="broadcast-modal-msg">
                {isMultiLangEnabled ? "Also Please" : "Please"} review your
                submission carefully before proceeding. Submitting the broadcast
                multiple times or including duplicate records for a patient in
                your file will result in duplicate messages being sent.
              </p>
            </>
          );
        };

        const updatedHeaders = getUpdatedHeaders(
          values.convoType,
          values.sendSurvey,
        );
        return (
          <>
            {state.deleteTemplateModal && (
              <ConfirmPopup
                isDelete
                titleMessage="Confirm to Delete"
                handleCancel={() =>
                  setState((st) => ({
                    ...st,
                    deleteTemplateModal: !state.deleteTemplateModal,
                  }))
                }
                handleDelete={() => deleteTemplate(setFieldValue)}
                isVisible={state.deleteTemplateModal}
                submitButtonText="Delete"
                cancelButtonText="Cancel"
                message={
                  <>
                    <div>
                      Are you sure you want to delete{" "}
                      <strong> {state.deleteTemplateData.templateName} </strong>
                      <strong> {state.deleteTemplateData.name} </strong>
                      from saved templates?
                    </div>
                    {state.deleteTemplateData?.showAs === "default" && (
                      <em>
                        Deleting this default template will also remove it for
                        all other accounts.
                      </em>
                    )}
                  </>
                }
              />
            )}
            {state.sendMessageState && (
              <CustomModal
                title={getModalTitle()}
                handleCancel={() =>
                  setState((st) => ({
                    ...st,
                    sendMessageState: !state.sendMessageState,
                    isDuplicatedEntry: false,
                  }))
                }
                handleDelete={() => confirmSubmitForm(values)}
                isVisible={state.sendMessageState}
                submitButtonText="Confirm"
                cancelButtonText="Cancel"
                customClass="custom-override-modal"
              >
                {getModalContent()}
              </CustomModal>
            )}

            <CustomModal
              title="Confirm your Submission"
              handleCancel={() =>
                setState((st) => ({
                  ...st,
                  showDuplicateEntryModal: false,
                  isDuplicatedEntry: false,
                }))
              }
              handleDelete={checkOverrideWindow}
              isVisible={state.showDuplicateEntryModal}
              submitButtonText="Confirm"
              cancelButtonText="Cancel"
              customClass="custom-override-modal"
            >
              {getDuplicateModalContent()}
            </CustomModal>

            {state.scheduleModal && (
              <AddEditSchedule
                title="Schedule Broadcast Messages"
                edit={false}
                isVisible={state.scheduleModal}
                hideScheduleModal={() => hideScheduleModal()}
                getScheduledMsgData={getScheduledMsgData}
                msgValues={{
                  ...formatMessageValues(values),
                  translationObject: state.translationObject || {},
                }}
                onCancel={onCancel}
                showBroadcastResend={showBroadcastResend}
                typeLabel={typeLabel}
                handleParentLoading={handleParentLoading}
                getEmployeeSendAnotherMsg={getEmployeeSendAnotherMsg}
                formatMessageValues={formatMessageValues}
                disableSendSchedule={
                  typeLabel === "Patients" &&
                  isMultiLang &&
                  state.hasScheduleTranslationError
                }
                toggleScheduleDuplicationModal={toggleScheduleDuplicationModal}
                showDuplicateEntryModal={state.showDuplicateEntryModal}
                sendMessageState={state.sendMessageState}
                onSubmit={onSubmitForm}
              />
            )}
            <CustomModal
              title="Confirm your Submission"
              handleCancel={() =>
                setState((st) => ({
                  ...st,
                  showScheduleDuplicationModal: false,
                  isDuplicatedEntry: false,
                  scheduleDuplicationModalData: {},
                }))
              }
              handleDelete={() => {
                handleParentLoading(true);
                state.scheduleDuplicationModalData.scheduleBroadcast(
                  state.scheduleDuplicationModalData?.updatedValues,
                );
                handleParentLoading(false);
              }}
              isVisible={state.showScheduleDuplicationModal}
              submitButtonText="Confirm"
              cancelButtonText="Cancel"
              customClass="custom-override-modal"
            >
              {getDuplicateModalContent()}
            </CustomModal>

            {(current === 1 || width > MOBILE_WIDTH) && (
              <Form className="broadcast-message-form">
                {state.createTemplate ? (
                  <CreateEmailTemplate
                    mergeTags={formatTableColumns(headers, values.convoType)}
                    templateId={values.emailTemplateId}
                    onBack={() =>
                      setState((st) => ({
                        ...st,
                        createTemplate: false,
                      }))
                    }
                    onSave={(template) => {
                      updateEmailTemplateList().then(() => {
                        setFieldValue("emailTemplateId", template.id);
                      });
                      setState((st) => ({
                        ...st,
                        createTemplate: undefined,
                      }));
                    }}
                    onUpdate={() => {
                      updateEmailTemplateList();
                      setState((st) => ({
                        ...st,
                        createTemplate: undefined,
                      }));
                    }}
                    practiceId={practiceId}
                    isTemplateModificationAllowed={
                      isTemplateModificationAllowed
                    }
                    fetchAccounts={fetchAccounts}
                    accountsList={accountsList}
                    allAccountsList={allAccountsList}
                    formValues={values}
                    setFieldValue={setFieldValue}
                  />
                ) : (
                  <>
                    <div className="broadcast-form-container">
                      <div className="header">
                        <div className="title desktop-version">
                          Send Broadcast Message
                        </div>
                        <div className="title mobile-version">
                          Broadcast Message
                        </div>
                        <div className="actions desktop-version">
                          <ActionTemplate
                            isValid={isValid}
                            dirty={dirty}
                            values={values}
                          />
                        </div>
                      </div>
                      <div
                        className={`form-row message-type-row ${
                          values.convoType === CONVO_TYPE.IVR
                            ? "row-with-borders"
                            : ""
                        }`}
                      >
                        <CustomLabel
                          title="Message Type"
                          required={!isMobileScreen}
                        />

                        <section className="custom-dailog-type-wrapper">
                          <CustomSelect
                            required
                            name="convoType"
                            placeholder="Message Type"
                            optionKeyProp="value"
                            options={getFilteredModalityTypes(
                              isDirectTextInput,
                              typeLabel,
                              state.isRcsForBroadcast,
                            )}
                            optionValueProp="value"
                            optionLabelProp="label"
                            onChange={(val) => {
                              resetForm();
                              setFieldValue("convoType", val);
                              setFieldValue("language", "eng");
                              setTimeout(validateForm, 0);
                              setSelectedTemplate(null);
                              if (CONVO_TYPE.RCS === val) {
                                fetchRcsTemplates(practiceId);
                              }
                            }}
                            noSortOptions
                          />
                        </section>
                      </div>

                      {!isPatientMultiLang && (
                        <div className="form-row template-row">
                          <CustomLabel title="Language" />
                          <FormikSelect
                            name="language"
                            disabled={values.convoType === CONVO_TYPE.EMAIL}
                            onChange={() => {
                              setFieldValue("message", "");
                              setFieldValue("messageType", false);
                              setTimeout(validateForm, 0);
                            }}
                            getPopupContainer={(trigger) => trigger.parentNode}
                            className="custom-select"
                          >
                            {state.languageState.map((item) => (
                              <Option
                                key={item.value}
                                value={item.value}
                                label={item.label}
                                className="languages-dropdown-container"
                              >
                                <Tooltip title={item.label}>
                                  <span className="dropdown-label">
                                    {item.label}
                                  </span>
                                </Tooltip>
                                <Tooltip
                                  title={item.voice?.replace("-Neural", "")}
                                >
                                  <span className="dropdown-meta">
                                    {VoiceIcon}
                                    <span className="voice-label">
                                      {item.voice?.replace("-Neural", "")}
                                    </span>
                                  </span>
                                </Tooltip>
                              </Option>
                            ))}
                          </FormikSelect>
                        </div>
                      )}

                      {values.convoType === CONVO_TYPE.SMS && (
                        <div className="form-row survey-row">
                          <CustomInput
                            type="checkbox"
                            title="Send Survey"
                            name="sendSurvey"
                            onChange={(e) => {
                              setFieldValue("sendSurvey", e.target.checked);
                              setFieldValue("surveyTemplateId", "");
                            }}
                            checked={values.sendSurvey}
                          />
                        </div>
                      )}
                      {values.sendSurvey && (
                        <section className="form-row message-type-row ">
                          <CustomLabel
                            title="Survey Template"
                            required={true}
                          />
                          <CustomSelect
                            required
                            name="surveyTemplateId"
                            placeholder="Select Template"
                            optionKeyProp="value"
                            options={state?.surveyTemplateList}
                            optionValueProp="id"
                            optionLabelProp="name"
                            onChange={(val) => {
                              setFieldValue("surveyTemplateId", val);
                              setTimeout(validateForm, 0);
                            }}
                            noSortOptions
                            showSearch={true}
                            notFoundContent="Not available"
                          />
                        </section>
                      )}
                      <If condition={values.convoType === CONVO_TYPE.IVR}>
                        <Then>
                          <div className="form-row response-message-row">
                            <CustomInput
                              type="switch"
                              title="Subtype"
                              pretext="Text"
                              posttext="Audio"
                              name="subtype"
                              active={values?.subtype?.toString()}
                              onChange={(value) => {
                                setFieldValue("subtype", value);
                                setFieldValue("message", "");
                                setFieldValue("messageType", false);

                                setTimeout(validateForm, 0);
                              }}
                            />
                          </div>
                        </Then>
                      </If>
                      <If condition={values.convoType === CONVO_TYPE.RCS}>
                        <Then>
                          <div className="form-row template-row">
                            <CustomLabel title="RCS Template" required />
                            <CustomSelect
                              required
                              name="rcsTemplateId"
                              placeholder="Select RCS Template"
                              options={
                                rcsData.data?.map((t) => ({
                                  key: t.contentTemplateSid,
                                  value: t.name,
                                  label: t.name,
                                })) || []
                              }
                              optionLabelProp="value"
                              optionValueProp="key"
                              onChange={(val) => {
                                handleRcsTemplateChange(val, setFieldValue);
                              }}
                              noSortOptions
                              showSearch={true}
                              notFoundContent="Not available"
                            />
                          </div>
                        </Then>
                      </If>

                      <If condition={values.convoType === CONVO_TYPE.EMAIL}>
                        <Then>
                          <div className="form-row email-template-row">
                            <CustomLabel title="Email Template" required />
                            <section className="custom-dailog-type-wrapper">
                              <TemplateSelect
                                required
                                name="emailTemplateId"
                                placeholder="Select Email Template"
                                className={
                                  touched.emailTemplateId &&
                                  errors.emailTemplateId
                                    ? "error-box"
                                    : ""
                                }
                                optionValueProp="id"
                                optionLabelProp="label"
                                hideErrorMessage
                                disabled={!currentUser.fromEmail}
                              >
                                <option value="" label="Choose">
                                  Choose
                                </option>
                                {state.emailTemplatesList.map((item) => {
                                  return (
                                    <option
                                      key={item.id}
                                      value={item.id}
                                      label={item.name}
                                      className="email-template-option"
                                    >
                                      <span className="option-overflow">
                                        {item?.name}
                                      </span>
                                      {item.id && (
                                        <span className="option-overflow-items">
                                          {item.showAs === "default" ? (
                                            <>
                                              {item.updatedAt}
                                              <span>
                                                {" "}
                                                {BroadcastTemplateDivider}
                                                {" Default"}
                                              </span>
                                            </>
                                          ) : (
                                            <>
                                              {item.updatedAt}
                                              <span>
                                                {" "}
                                                {BroadcastTemplateDivider}
                                                {" By "}
                                                {item.user?.name}
                                              </span>
                                            </>
                                          )}
                                          {((isTemplateModificationAllowed &&
                                            item.showAs === "default") ||
                                            (!isTemplateModificationAllowed &&
                                              item.showAs !== "default")) && (
                                            <CustomButton
                                              btntype="clear"
                                              title={deleteIcon}
                                              className="delete-icon"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setState((st) => ({
                                                  ...st,
                                                  deleteTemplateModal: !state.deleteTemplateModal,
                                                  deleteTemplateData: item,
                                                  deleteTemplateType:
                                                    CONVO_TYPE.EMAIL,
                                                }));
                                              }}
                                            />
                                          )}
                                        </span>
                                      )}
                                    </option>
                                  );
                                })}
                              </TemplateSelect>
                            </section>
                            <If condition={!isMobileScreen}>
                              <CustomButton
                                disabled={
                                  !currentUser.fromEmail &&
                                  !values.emailTemplateId
                                }
                                btntype="clear"
                                className={
                                  !currentUser.fromEmail &&
                                  !values.emailTemplateId
                                    ? "disable-button"
                                    : ""
                                }
                                onClick={() =>
                                  createNewTemplateHandler(
                                    values,
                                    setFieldValue,
                                  )
                                }
                                title={
                                  values.emailTemplateId
                                    ? "Edit Template"
                                    : "Create New Template"
                                }
                              />
                            </If>
                          </div>
                          <div className={`form-row email-column-row`}>
                            <CustomLabel title="Email Column" required />
                            <section className="custom-dailog-type-wrapper">
                              <CustomSelect
                                required
                                name="emailColumn"
                                disabled={!currentUser.fromEmail}
                                placeholder="Select Column"
                                optionKeyProp="Header"
                                options={formatTableColumns(
                                  headers,
                                  values.convoType,
                                )}
                                optionValueProp="accessor"
                                optionLabelProp="Header"
                                onChange={(val) => {
                                  setFieldValue("emailColumn", val);
                                }}
                                noSortOptions
                                hideErrorMessage
                              />
                            </section>
                          </div>
                          <div className="form-row email-subject-row">
                            <CustomLabel title="Email Subject" required />
                            <section className="custom-dailog-type-wrapper">
                              <CustomInput
                                type="textarea"
                                name="emailSubject"
                                resize="none"
                                placeholder="Type Subject"
                                className="ant-textarea"
                                rows="4"
                                hideError
                                disabled={!currentUser.fromEmail}
                              />
                            </section>
                          </div>
                        </Then>

                        <Else>
                          {/* else */}
                          <section
                            className={`${
                              !values.subtype ? "row-with-borders" : ""
                            } ${values.messageType ? "large" : ""}`}
                          >
                            <If condition={!values.subtype}>
                              <Then>
                                <div className="form-row response-message-row">
                                  <If condition={isMobileScreen}>
                                    <Then>
                                      <div className="custom-switch-wrapper">
                                        <span
                                          className={`pre-text ${
                                            values.messageType.toString() ===
                                            "false"
                                              ? "active"
                                              : ""
                                          }`}
                                        >
                                          Custom Message
                                        </span>
                                        <Switch
                                          name="messageType"
                                          onChange={(value) => {
                                            setFieldValue(
                                              "messageType",
                                              !value,
                                            );
                                            setFieldValue("message", "");
                                            setTimeout(validateForm, 0);
                                            listOfTemplates();
                                            handleReset(
                                              setFieldValue,
                                              "template",
                                            );
                                          }}
                                          className={
                                            values.messageType.toString() ===
                                            "false"
                                              ? ""
                                              : "disable-message"
                                          }
                                          defaultChecked={
                                            isMobileScreen
                                              ? !values.messageType
                                              : values.messageType
                                          }
                                          checked={
                                            isMobileScreen
                                              ? !values.messageType
                                              : values.messageType
                                          }
                                        />
                                      </div>
                                    </Then>
                                    <Else>
                                      <CustomInput
                                        type="switch"
                                        title="Broadcast Message"
                                        pretext="Custom Message"
                                        posttext="Template Message"
                                        name="messageType"
                                        active={
                                          isMobileScreen
                                            ? !values.messageType.toString()
                                            : values.messageType.toString()
                                        }
                                        required
                                        onChange={(value) => {
                                          setFieldValue("messageType", value);
                                          setFieldValue("message", "");
                                          setFieldValue("rcsTempMessage", "");
                                          setFieldValue("rcsMessage", "");
                                          setTimeout(validateForm, 0);
                                          listOfTemplates(values.convoType);
                                          handleReset(
                                            setFieldValue,
                                            "template",
                                          );
                                        }}
                                      />
                                    </Else>
                                  </If>
                                </div>
                              </Then>
                            </If>

                            <If
                              condition={values.messageType && !values.subtype}
                            >
                              <Then>
                                <div className="form-row template-row">
                                  <CustomLabel
                                    required={!isMobileScreen}
                                    title="Template Name"
                                  />
                                  <TemplateSelect
                                    name="template"
                                    className={`
                        common-select-field template-select-field ${
                          touched.templateName && errors.templateName
                            ? "error-box"
                            : ""
                        }`}
                                    placeholder="Select Template"
                                    showSearch={true}
                                    notFoundContent="Not available" 
                                    getPopupContainer={(trigger) =>
                                      trigger.parentNode
                                    }
                                    onChange={(value, label) => {
                                      if (values.convoType !== CONVO_TYPE.RCS) {
                                        setFieldValue("template", label);
                                        getTemplateMsg(
                                          value,
                                          setFieldValue,
                                          "message",
                                          "tempMessage",
                                        );
                                      } else {
                                        setFieldValue("template", label);
                                        getTemplateMsg(
                                          value,
                                          setFieldValue,
                                          "rcsMessage",
                                          "rcsTempMessage",
                                        );
                                      }
                                    }}
                                    disabled={state.templateInEditState && true}
                                  >
                                    {state.templates.map(function(item) {
                                      return (
                                        <option
                                          key={item.id}
                                          value={item.id}
                                          label={item.templateName}
                                        >
                                          <span className="option-overflow-main full-width">
                                            <span className="option-overflow">
                                              {item?.templateName}
                                            </span>
                                            <span className="option-overflow-items">
                                              {item.showAs === "default" ? (
                                                <>
                                                  {item.updatedAt}
                                                  <span>
                                                    {" "}
                                                    {BroadcastTemplateDivider}
                                                    {" Default"}
                                                  </span>
                                                </>
                                              ) : (
                                                <>
                                                  {item.updatedAt}
                                                  <span>
                                                    {" "}
                                                    {BroadcastTemplateDivider}
                                                    {" By "}
                                                    {item?.user?.name}
                                                  </span>
                                                </>
                                              )}
                                            </span>
                                          </span>
                                          {((isTemplateModificationAllowed &&
                                            item.showAs === "default") ||
                                            (!isTemplateModificationAllowed &&
                                              item.showAs !== "default")) && (
                                            <CustomButton
                                              btntype="clear"
                                              title={deleteIcon}
                                              className="delete-icon"
                                              onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                setState((st) => ({
                                                  ...st,
                                                  deleteTemplateModal: !state.deleteTemplateModal,
                                                  deleteTemplateData: item,
                                                  deleteTemplateType:
                                                    values.convoType ===
                                                    CONVO_TYPE.RCS
                                                      ? "rcs"
                                                      : "",
                                                }));
                                              }}
                                            />
                                          )}
                                        </option>
                                      );
                                    })}
                                  </TemplateSelect>
                                </div>
                              </Then>
                            </If>

                            <If condition={values.convoType === CONVO_TYPE.RCS}>
                              <Then>
                                <section>
                                  <div className="form-row custom-message-row">
                                    <CustomLabel
                                      required={!isMobileScreen}
                                      customClass="text-area-message"
                                      title={
                                        values.messageType
                                          ? "Template RCS Message"
                                          : "Custom RCS Message"
                                      }
                                    />

                                    <SendMessageRcs
                                      name="rcsMessage"
                                      selectedTempType="template"
                                      tempName="rcsTempMessage"
                                      convoType={values.convoType}
                                      headers={formatHeaders(
                                        headers,
                                        values.convoType,
                                      )}
                                      modal={modal}
                                      loading={loading}
                                      formValues={values}
                                      data={data}
                                      setFieldValue={setFieldValue}
                                      isTemplate={values.messageType}
                                      touched={touched}
                                      errors={errors}
                                      type={getrcsTemplateType()}
                                      templates={state.templates}
                                      listOfTemplates={() =>
                                        listOfTemplates(values.convoType)
                                      }
                                      parentState={setState}
                                      setAudioRef={setAudioRef}
                                      audioRef={audioRef}
                                      setFormattedMessage={setFormattedMessage}
                                      saveChangesAllowed={
                                        isTemplateModificationAllowed
                                      }
                                      fetchAccounts={fetchAccounts}
                                      allAccountsList={allAccountsList}
                                      accountsList={accountsList}
                                      selectedRcsTemplate={selectedTemplate}
                                      currentIndex={currentIndex}
                                      setCurrentIndex={setCurrentIndex}
                                      onResetEditTemplate={() =>
                                        setState((st) => ({
                                          ...st,
                                          templateInEditState: false,
                                        }))
                                      }
                                    />
                                  </div>
                                </section>
                              </Then>
                            </If>

                            {values.convoType !== CONVO_TYPE.RCS && (
                              <div className="form-row custom-message-row">
                                <CustomLabel
                                  required={!isMobileScreen}
                                  customClass="text-area-message"
                                  title={
                                    values.messageType
                                      ? isMobileScreen
                                        ? "Template"
                                        : `Template ${
                                            values.convoType === CONVO_TYPE.AUTO
                                              ? "SMS"
                                              : ""
                                          } Message`
                                      : isMobileScreen
                                        ? "Message"
                                        : `Custom ${
                                            values.convoType === CONVO_TYPE.AUTO
                                              ? "SMS"
                                              : ""
                                          } Message`
                                  }
                                />
                                <SendMessage
                                  name="message"
                                  selectedTempType="template"
                                  tempName="tempMessage"
                                  convoType={values.convoType}
                                  headers={formatHeaders(
                                    updatedHeaders,
                                    values.convoType,
                                  )}
                                  modal={modal}
                                  loading={loading}
                                  formValues={values}
                                  data={data}
                                  setFieldValue={setFieldValue}
                                  isTemplate={values.messageType}
                                  touched={touched}
                                  errors={errors}
                                  type={getType(typeLabel, values.convoType)}
                                  templates={state.templates}
                                  listOfTemplates={() =>
                                    listOfTemplates(values.convoType)
                                  }
                                  parentState={setState}
                                  subtype={values.subtype}
                                  setAudioRef={setAudioRef}
                                  audioRef={audioRef}
                                  setFormattedMessage={setFormattedMessage}
                                  saveChangesAllowed={
                                    isTemplateModificationAllowed
                                  }
                                  fetchAccounts={fetchAccounts}
                                  allAccountsList={allAccountsList}
                                  accountsList={accountsList}
                                />
                              </div>
                            )}
                          </section>
                          <If condition={values.convoType === CONVO_TYPE.AUTO}>
                            <Then>
                              <div>
                                <div className="form-row sms-for-ivr sms-ivr-row">
                                  <CustomInput
                                    type="checkbox"
                                    title="Use SMS For IVR"
                                    name="useSmsForIVR"
                                    onChange={(e) => {
                                      setFieldValue(
                                        "ivrMessageType",
                                        messageTypes.custom,
                                      );
                                      setFieldValue("ivrMessage", "");
                                      setFieldValue("ivrTemplate", "");
                                      setFieldValue(
                                        "useSmsForIVR",
                                        e.target.checked,
                                      );
                                    }}
                                    checked={values.useSmsForIVR}
                                  />
                                </div>

                                <If condition={!values.useSmsForIVR}>
                                  <Then>
                                    <div className="form-row ivr-message-row">
                                      <CustomInput
                                        type="switch"
                                        title="IVR Message"
                                        pretext="Custom Message"
                                        posttext="Template Message"
                                        name="ivrMessageType"
                                        active={
                                          values.ivrMessageType ===
                                          messageTypes.template
                                        }
                                        required
                                        onChange={(value) => {
                                          const type = value
                                            ? messageTypes.template
                                            : messageTypes.custom;
                                          setFieldValue("ivrMessageType", type);
                                          setFieldValue("ivrMessage", "");
                                          setTimeout(validateForm, 0);
                                          listOfIvrTemplates();
                                          handleReset(
                                            setFieldValue,
                                            "ivrTemplate",
                                          );
                                        }}
                                      />
                                    </div>

                                    <If
                                      condition={
                                        values.ivrMessageType ===
                                        messageTypes.template
                                      }
                                    >
                                      <Then>
                                        <div className="form-row template-row">
                                          <CustomLabel
                                            required={!isMobileScreen}
                                            title="Template Name"
                                          />
                                          <TemplateSelect
                                            name="ivrTemplate"
                                            className={`
                        common-select-field template-select-field ${
                          touched.templateName && errors.templateName
                            ? "error-box"
                            : ""
                        }`}
                                            placeholder="Select Template"
                                            getPopupContainer={(trigger) =>
                                              trigger.parentNode
                                            }
                                            onChange={(value, label) => {
                                              setFieldValue(
                                                "ivrTemplate",
                                                label,
                                              );
                                              getTemplateMsg(
                                                value,
                                                setFieldValue,
                                                "ivrMessage",
                                                "ivrTempMessage",
                                              );
                                            }}
                                            disabled={
                                              state.templateInEditState && true
                                            }
                                          >
                                            {state.ivrTemplates.map(function(
                                              item,
                                            ) {
                                              return (
                                                <option
                                                  key={item.id}
                                                  value={item.id}
                                                  label={item?.templateName}
                                                >
                                                  <span className="option-overflow-main full-width">
                                                    <span className="option-overflow">
                                                      {item?.templateName}
                                                    </span>
                                                    <span className="option-overflow-items">
                                                      {item.showAs ===
                                                      "default" ? (
                                                        <>
                                                          {item.updatedAt}
                                                          <span>
                                                            {" "}
                                                            {
                                                              BroadcastTemplateDivider
                                                            }
                                                            {" Default"}
                                                          </span>
                                                        </>
                                                      ) : (
                                                        <>
                                                          {item.updatedAt}
                                                          <span>
                                                            {" "}
                                                            {
                                                              BroadcastTemplateDivider
                                                            }
                                                            {" By "}
                                                            {item?.user?.name}
                                                          </span>
                                                        </>
                                                      )}
                                                    </span>
                                                  </span>
                                                  {((isTemplateModificationAllowed &&
                                                    item.showAs ===
                                                      "default") ||
                                                    (!isTemplateModificationAllowed &&
                                                      item.showAs !==
                                                        "default")) && (
                                                    <CustomButton
                                                      btntype="clear"
                                                      title={deleteIcon}
                                                      className="delete-icon"
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();
                                                        setState((st) => ({
                                                          ...st,
                                                          deleteTemplateModal: !state.deleteTemplateModal,
                                                          deleteTemplateData: item,
                                                          deleteTemplateType:
                                                            CONVO_TYPE.IVR,
                                                        }));
                                                      }}
                                                    />
                                                  )}
                                                </option>
                                              );
                                            })}
                                          </TemplateSelect>
                                        </div>
                                      </Then>
                                    </If>

                                    <div className="form-row custom-message-row">
                                      <CustomLabel
                                        required={!isMobileScreen}
                                        customClass="text-area-message"
                                        title={
                                          values.ivrMessageType ===
                                          messageTypes.template
                                            ? isMobileScreen
                                              ? "Template"
                                              : "Template IVR Message"
                                            : isMobileScreen
                                              ? "Message"
                                              : "Custom IVR Message"
                                        }
                                      />
                                      <SendMessage
                                        name="ivrMessage"
                                        selectedTempType="ivrTemplate"
                                        tempName="ivrTempMessage"
                                        convoType={values.convoType}
                                        headers={formatHeaders(
                                          headers,
                                          values.convoType,
                                        )}
                                        modal={modal}
                                        loading={loading}
                                        formValues={values}
                                        data={data}
                                        setFieldValue={setFieldValue}
                                        isTemplate={
                                          values.ivrMessageType ===
                                          messageTypes.template
                                        }
                                        touched={touched}
                                        errors={errors}
                                        type={getIvrTemplateType()}
                                        templates={state.ivrTemplates}
                                        listOfTemplates={listOfIvrTemplates}
                                        parentState={setState}
                                        subtype={values.subtype}
                                        setAudioRef={setAudioRef}
                                        audioRef={audioRef}
                                        setFormattedMessage={
                                          setFormattedMessage
                                        }
                                        saveChangesAllowed={
                                          isTemplateModificationAllowed
                                        }
                                        fetchAccounts={fetchAccounts}
                                        allAccountsList={allAccountsList}
                                        accountsList={accountsList}
                                        showSegmentedArtifacts={false}
                                      />
                                    </div>
                                  </Then>
                                </If>
                              </div>
                            </Then>
                          </If>

                          <If condition={values.convoType !== CONVO_TYPE.IVR}>
                            <div>
                              <div className="form-row enable-optout enable-optout-row">
                                <CustomInput
                                  type="checkbox"
                                  title="Enable Opt-out"
                                  name="enableOptOut"
                                  onChange={(e) => {
                                    setFieldValue(
                                      "optOutMessageType",
                                      messageTypes.custom,
                                    );
                                    setFieldValue(
                                      "optOutMessage",
                                      e.target.checked
                                        ? "For SMS service, to opt-out of receiving messages, text STOP. To restart messages text START."
                                        : "",
                                    );
                                    setFieldValue(
                                      "enableOptOut",
                                      e.target.checked,
                                    );
                                  }}
                                  checked={values.enableOptOut}
                                />
                              </div>
                              <If condition={state.responseMsgEnabled}>
                                <Then>
                                  <div className="form-row opt-out-message-row">
                                    <CustomInput
                                      type="switch"
                                      title="Response Message"
                                      pretext="Custom Message"
                                      posttext="Template Message"
                                      name="responseMessageType"
                                      active={
                                        values.responseMessageType ===
                                        messageTypes.template
                                      }
                                      required
                                      onChange={(value) => {
                                        const type = value
                                          ? messageTypes.template
                                          : messageTypes.custom;
                                        setFieldValue(
                                          "responseMessageType",
                                          type,
                                        );
                                        setTimeout(validateForm, 0);
                                        setFieldValue("responseMessage", "");
                                        if (value) {
                                          listOfSmsTemplates();
                                        }
                                        handleReset(
                                          setFieldValue,
                                          "responseMessage",
                                        );
                                      }}
                                    />
                                  </div>
                                  <If
                                    condition={
                                      values.responseMessageType ===
                                      messageTypes.template
                                    }
                                  >
                                    <Then>
                                      <div className="form-row template-row">
                                        <CustomLabel
                                          required={!isMobileScreen}
                                          title="Template Name"
                                        />
                                        <TemplateSelect
                                          name="responseTemplate"
                                          className={`
                        common-select-field template-select-field ${
                          touched.templateName && errors.templateName
                            ? "error-box"
                            : ""
                        }`}
                                          placeholder="Select Template"
                                          getPopupContainer={(trigger) =>
                                            trigger.parentNode
                                          }
                                          onChange={(value, label) => {
                                            setFieldValue(
                                              "responseTemplate",
                                              label,
                                            );
                                            getTemplateMsg(
                                              value,
                                              setFieldValue,
                                              "responseMessage",
                                              "responseTempMessage",
                                            );
                                          }}
                                          disabled={
                                            state.templateInEditState && true
                                          }
                                        >
                                          {state.smsTemplates.map(function(
                                            item,
                                          ) {
                                            return (
                                              <option
                                                key={item.id}
                                                value={item.id}
                                                label={item.templateName}
                                              >
                                                <span className="option-overflow-main">
                                                  <span className="option-overflow">
                                                    {item?.templateName}
                                                  </span>
                                                  <span className="option-overflow-items">
                                                    {item?.updatedAt}
                                                    <span>
                                                      {" "}
                                                      <>
                                                        {
                                                          BroadcastTemplateDivider
                                                        }
                                                      </>
                                                      {" By "}
                                                      {item?.user?.name}
                                                    </span>
                                                  </span>
                                                </span>
                                                <CustomButton
                                                  btntype="clear"
                                                  title={deleteIcon}
                                                  className="delete-icon"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setState((st) => ({
                                                      ...st,
                                                      deleteTemplateModal: !state.deleteTemplateModal,
                                                      deleteTemplateData: item,
                                                      deleteTemplateType:
                                                        "b-reply",
                                                    }));
                                                  }}
                                                />
                                              </option>
                                            );
                                          })}
                                        </TemplateSelect>
                                      </div>
                                    </Then>
                                  </If>
                                  <div className="form-row custom-message-row">
                                    <CustomLabel
                                      required={!isMobileScreen}
                                      customClass="text-area-message"
                                      title={
                                        values.responseMessageType ===
                                        messageTypes.template
                                          ? isMobileScreen
                                            ? "Template"
                                            : "Response Message"
                                          : isMobileScreen
                                            ? "Message"
                                            : "Response Message"
                                      }
                                    />
                                    <SendMessage
                                      name="responseMessage"
                                      selectedTempType="responseTemplate"
                                      tempName="responseTempMessage"
                                      hasFieldVariables={false}
                                      convoType={values.convoType}
                                      headers={formatHeaders(
                                        [liveChatFieldVariable, ...headers],
                                        values.convoType,
                                      )}
                                      modal={modal}
                                      loading={loading}
                                      formValues={values}
                                      data={[
                                        {
                                          LiveChatNumber: state.liveChatNumber,
                                        },
                                      ]}
                                      setFieldValue={setFieldValue}
                                      isTemplate={
                                        values.responseMessageType ===
                                        messageTypes.template
                                      }
                                      touched={touched}
                                      errors={errors}
                                      type="b-reply"
                                      templates={state.smsTemplates}
                                      listOfTemplates={listOfSmsTemplates}
                                      parentState={setState}
                                      setAudioRef={setAudioRef}
                                      audioRef={audioRef}
                                      setFormattedMessage={setFormattedMessage}
                                      saveChangesAllowed={true}
                                    />
                                  </div>
                                </Then>
                              </If>
                              <If condition={values.enableOptOut}>
                                <Then>
                                  <div className="form-row opt-out-message-row">
                                    <CustomInput
                                      type="switch"
                                      title="Opt-Out Message"
                                      pretext="Custom Message"
                                      posttext="Template Message"
                                      name="optOutMessageType"
                                      active={
                                        values.optOutMessageType ===
                                        messageTypes.template
                                      }
                                      required
                                      onChange={(value) => {
                                        const type = value
                                          ? messageTypes.template
                                          : messageTypes.custom;
                                        setFieldValue(
                                          "optOutMessageType",
                                          type,
                                        );
                                        setFieldValue("optOutMessage", "");
                                        setTimeout(validateForm, 0);
                                        listOfOptOutTemplates();
                                        handleReset(
                                          setFieldValue,
                                          "optOutMessage",
                                        );
                                      }}
                                    />
                                  </div>
                                  <If
                                    condition={
                                      values.optOutMessageType ===
                                      messageTypes.template
                                    }
                                  >
                                    <Then>
                                      <div className="form-row template-row">
                                        <CustomLabel
                                          required={!isMobileScreen}
                                          title="Template Name"
                                        />
                                        <TemplateSelect
                                          name="optOutTemplate"
                                          className={`
                        common-select-field template-select-field ${
                          touched.templateName && errors.templateName
                            ? "error-box"
                            : ""
                        }`}
                                          placeholder="Select Template"
                                          getPopupContainer={(trigger) =>
                                            trigger.parentNode
                                          }
                                          onChange={(value, label) => {
                                            setFieldValue(
                                              "optOutTemplate",
                                              label,
                                            );
                                            getTemplateMsg(
                                              value,
                                              setFieldValue,
                                              "optOutMessage",
                                              "optOutTempMessage",
                                            );
                                          }}
                                          disabled={
                                            state.templateInEditState && true
                                          }
                                        >
                                          {state.optOutTemplates.map(function(
                                            item,
                                          ) {
                                            return (
                                              <option
                                                key={item.id}
                                                value={item.id}
                                                label={item.templateName}
                                              >
                                                <span className="option-overflow-main full-width">
                                                  <span className="option-overflow">
                                                    {item?.templateName}
                                                  </span>
                                                  <span className="option-overflow-items">
                                                    {item?.updatedAt}
                                                    <span>
                                                      {" "}
                                                      <>
                                                        {
                                                          BroadcastTemplateDivider
                                                        }
                                                      </>
                                                      {" By "}
                                                      {item?.user?.name}
                                                    </span>
                                                  </span>
                                                </span>
                                                <CustomButton
                                                  btntype="clear"
                                                  title={deleteIcon}
                                                  className="delete-icon"
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    e.stopPropagation();
                                                    setState((st) => ({
                                                      ...st,
                                                      deleteTemplateModal: !state.deleteTemplateModal,
                                                      deleteTemplateData: item,
                                                      deleteTemplateType:
                                                        "opt-out",
                                                    }));
                                                  }}
                                                />
                                              </option>
                                            );
                                          })}
                                        </TemplateSelect>
                                      </div>
                                    </Then>
                                  </If>
                                  <div className="form-row custom-message-row">
                                    <CustomLabel
                                      required={!isMobileScreen}
                                      customClass="text-area-message"
                                      title={
                                        values.optOutMessageType ===
                                        messageTypes.template
                                          ? isMobileScreen
                                            ? "Template"
                                            : "Opt-Out Message"
                                          : isMobileScreen
                                            ? "Message"
                                            : "Opt-Out Message"
                                      }
                                    />
                                    <SendMessage
                                      name="optOutMessage"
                                      selectedTempType="optOutTemplate"
                                      tempName="optOutTempMessage"
                                      hasFieldVariables={false}
                                      convoType={values.convoType}
                                      headers={formatHeaders(
                                        headers,
                                        values.convoType,
                                      )}
                                      modal={modal}
                                      loading={loading}
                                      formValues={values}
                                      data={data}
                                      setFieldValue={setFieldValue}
                                      isTemplate={
                                        values.optOutMessageType ===
                                        messageTypes.template
                                      }
                                      touched={touched}
                                      errors={errors}
                                      type="opt-out"
                                      templates={state.optOutTemplates}
                                      listOfTemplates={listOfOptOutTemplates}
                                      parentState={setState}
                                      setAudioRef={setAudioRef}
                                      audioRef={audioRef}
                                      setFormattedMessage={setFormattedMessage}
                                      saveChangesAllowed={true}
                                    />
                                  </div>
                                </Then>
                              </If>
                            </div>
                          </If>
                        </Else>
                      </If>
                    </div>
                    <If condition={showTable}>
                      <Then>
                        <div className="table-container">
                          <DataTable
                            headers={headers}
                            rowSelection={showCheckboxes && rowSelection}
                            columns={formatTableColumns(
                              headers,
                              values.convoType,
                            )}
                            loading={loading}
                            data={data}
                            fileName={
                              isDirectTextInput ? "Direct Text Input" : fileName
                            }
                            label={typeLabel}
                            getSuggestions={getSuggestions}
                            fetchTableData={fetchTableData}
                            count={count}
                          />
                        </div>
                      </Then>
                    </If>
                    <div className="bottom-bar">
                      <BottomBar
                        handleBackButton={onBackButtonClick}
                        handleNextButton={onNextButtonClick}
                        disabled={
                          !isValid ||
                          !dirty ||
                          loading ||
                          (values.audio ? state.isAudioValid : null)
                        }
                      />
                    </div>
                  </>
                )}
              </Form>
            )}
            {current === 2 && (
              <AddEditSchedule
                title="Schedule Broadcast Message"
                edit={false}
                isVisible={state.scheduleModal}
                hideScheduleModal={() => hideScheduleModal()}
                getScheduledMsgData={getScheduledMsgData}
                msgValues={formatMessageValues(values)}
                onCancel={onCancel}
                showBroadcastResend={showBroadcastResend}
                typeLabel={typeLabel}
                handleParentLoading={handleParentLoading}
                getEmployeeSendAnotherMsg={getEmployeeSendAnotherMsg}
                submitForm={submitForm}
                prevPage={prevPage}
                audioRef={audioRef}
                headers={formatHeaders(headers, values.convoType)}
                data={data}
                formatMessageValues={formatMessageValues}
                toggleScheduleDuplicationModal={toggleScheduleDuplicationModal}
                showDuplicateEntryModal={state.showDuplicateEntryModal}
                sendMessageState={state.sendMessageState}
                onSubmit={onSubmitForm}
              />
            )}
          </>
        );
      }}
    </Formik>
  );
};
export default BroadcastMessage;
